import { useEffect, useMemo, useState } from 'react';

import { useModal } from 'context/ModalContext';
import { ConfirmacaoDaAcao } from 'components/task-item/modal-actions/moldura-da-acao';

interface Props {
  callback: (obj: { id: string; message?: string }) => void;
  id: string;
  status: string | undefined;
  data?: any;
}

/** Finalizar a apreciação (ECN-57): mesmos textos por tipo do modal antigo, falando em "Ação ECOA". */
export default function ModalStop(props: Props) {
  const modalID = 'validation-stop';

  const { openModal, modalData, closeModal } = useModal();
  const { callback, id } = props;

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);

  const texts = useMemo(() => {
    if (!modalIsOpen) return undefined;

    if (!!modalData?.type && typeof modalData?.type === 'string') {
      if (modalData.type === 'double') {
        return {
          title: 'Não bonificar Ação ECOA',
          description: 'Ao confirmar a ação, essa Ação ECOA não receberá nenhuma pontuação extra. Deseja confirmar?',
        };
      } else if (modalData.type === 'promote') {
        return {
          title: 'Não promover Ação ECOA',
          description: 'Ao confirmar a ação, essa Ação ECOA não passará para o próximo nível. Deseja confirmar?',
        };
      } else if (modalData.type === 'pitstop') {
        return {
          title: 'Concluir apreciação da Ação ECOA',
          description: 'Ao concluir, essa Ação ECOA não será enviada para apreciação do Nível 3. Deseja confirmar?',
        };
      }
    }

    return {
      title: 'Concluir apreciação da Ação ECOA',
      description: 'Confirma a conclusão da apreciação dessa Ação ECOA nesse nível?',
    };
  }, [modalData, modalIsOpen]);

  useEffect(() => {
    if (typeof id === 'string' && typeof openModal === 'string' && openModal === `${modalID}-${id}`) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [id, openModal]);

  if (!modalIsOpen) return <></>;

  return (
    <ConfirmacaoDaAcao
      title={texts?.title ?? ''}
      onClose={() => closeModal()}
      onConfirm={() => {
        callback({ id: 'stop' });
        closeModal();
      }}
    >
      <p className="m-0">{texts?.description}</p>
    </ConfirmacaoDaAcao>
  );
}
